import { render, staticRenderFns } from "./ProjectDynamicInfoBar.vue?vue&type=template&id=54fed752&scoped=true"
import script from "./ProjectDynamicInfoBar.vue?vue&type=script&lang=ts"
export * from "./ProjectDynamicInfoBar.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDynamicInfoBar.vue?vue&type=style&index=0&id=54fed752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fed752",
  null
  
)

export default component.exports